import { toast } from "sonner"
import type { Brief } from "./model"
import { useUpdateBriefMutation } from "./api"
import { useT } from "@/i18n"

/**
 * Returns an archive/unarchive toggle with success and error toasts
 */
export default function useToggleArchived() {
  const { t } = useT("brief")
  const [updateBrief] = useUpdateBriefMutation()

  return async (brief: Brief) => {
    await updateBrief({ id: brief.id, archived: !brief.archived }).unwrap()
    toast.success(brief.archived ? t("unarchivedToast") : t("archivedToast"))
  }
}
